<template>
    <div class="et-debug-bar" :class="{ 'et-debug-bar--collapsed': DebugStore.debugSettings.collapsed }">
        <div class="et-debug-bar__content">
            <div>
                <button @click="home()">Home</button>
                <button v-if="DebugStore.debugSettings.data.lastSearchId" @click="goToLastSearchId()">
                    go to last searchId
                </button>
                <button>
                    <et-agnostic-router-link :to="{ path: '/account' }"> Account</et-agnostic-router-link>
                </button>
                <button>
                    <et-agnostic-router-link :to="{ path: '/customer-service' }">
                        Customer service
                    </et-agnostic-router-link>
                </button>
                <button>
                    <et-agnostic-router-link :to="{ path: '/test-modals' }"> Test modals</et-agnostic-router-link>
                </button>
                <button>
                    <et-agnostic-router-link :to="{ path: '/test' }"> Test</et-agnostic-router-link>
                </button>
            </div>
        </div>
        <div>
            <EtCheckboxWithLabel
                v-for="(_setting, key) in loggingSettings"
                :key="key"
                v-model="loggingSettings[key]"
                :description="`show ${key} logs`"
                @update:model-value="(value) => updateLoggingSettings(key, value)"
            />
        </div>

        <div class="et-debug-bar__state-status">
            <h2>Waiting on resolves:</h2>
            <p v-for="(_resolveValue, resolveKey) in unfinishedResolves" :key="resolveKey">
                {{ resolveKey }}
            </p>
        </div>

        <button class="et-debug-bar__collapse-button" @click="toggleDebugBar()">debugbar</button>
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed, watch } from 'vue';
    import { useRouter } from 'vue-router';

    import { useStoreContainer } from '~/container';

    import EtAgnosticRouterLink from '~/modules/core/components/EtAgnosticRouterLink.vue';
    import EtCheckboxWithLabel from '~/modules/form/components/EtCheckboxWithLabel.vue';

    import type { DebugSettings } from '~/modules/core/types/debug/DebugSettings';
    import { LegacyCoreRouteNames } from '~/router/names/core';
    import { LegacySearchResultsRouteNames } from '~/router/names/search-results';

    const { DebugStore, StateResolveStore } = useStoreContainer();
    const router = useRouter();

    watch(
        () => router.currentRoute.value,
        (currentRoute) => {
            if (currentRoute.params.searchId) {
                const settings = DebugStore.debugSettings;
                settings.data.lastSearchId = currentRoute.params.searchId as string;
                DebugStore.updateSettings(settings);
            }
        },
    );

    const unfinishedResolves = computed(() => {
        const resolves: Record<any, any> = {};

        const flattenedStateStatusResolves = storeToRefs(StateResolveStore).flattenedStateStatusResolves.value;

        for (const flattenedResolve in flattenedStateStatusResolves) {
            if (!flattenedStateStatusResolves[flattenedResolve].finished) {
                resolves[flattenedResolve] = flattenedStateStatusResolves[flattenedResolve];
            }
        }

        return resolves;
    });

    function home() {
        router.push({
            name: LegacyCoreRouteNames.RootPage,
        });
    }

    function goToLastSearchId() {
        router.push({
            name: LegacySearchResultsRouteNames.SearchResultsPage,
            params: { searchId: DebugStore.debugSettings.data.lastSearchId! },
        });
    }

    function toggleDebugBar() {
        DebugStore.updateSettings(
            Object.assign(DebugStore.debugSettings, { collapsed: !DebugStore.debugSettings.collapsed }),
        );
    }

    const loggingSettings = computed(() => DebugStore.debugSettings.logging);

    function updateLoggingSettings(key: keyof DebugSettings['logging'], value: boolean) {
        const settings = DebugStore.debugSettings;
        settings.logging[key] = value;
        DebugStore.updateSettings(settings);
    }
</script>
